// NGRX
import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
// CRUD
import { Doctor } from '../_models/doctor.model';
// Models
import { QueryParamsModel } from '../../_base/crud';

export enum DoctorActionTypes {
  AllDoctorsRequested = '[Doctors Module] All Doctors Requested',
  AllDoctorsLoaded = '[Doctors API] All Doctors Loaded',
  DoctorOnServerCreated = '[Edit Doctor Component] Doctor On Server Created',
  DoctorCreated = '[Edit Doctor Dialog] Doctor Created',
  DoctorOnServerUpdated = '[Edit Doctor Dialog] Doctor On Server Updated',
  DoctorUpdated = '[Edit Doctor Dialog] Doctor Updated',
  DoctorStatusOnServerUpdated = '[Doctors List Page] Doctor Status On Server Updated Updated',
  DoctorStatusUpdated = '[Doctors List Page] Doctor Status Updated Updated',
  DoctorsStatusOnServerUpdated = '[Doctors List Page] Doctors Status On Server Updated Updated',
  DoctorsStatusUpdated = '[Doctors List Page] Doctors Status Updated Updated',
  DoctorOnServerDeleted = '[Doctors List Page] Doctor On Server Deleted',
  DoctorDeleted = '[Doctors List Page] Doctor Deleted',
  ManyDoctorsOnServerDeleted = '[Doctors List Page] Doctors On Server Deleted',
  ManyDoctorsDeleted = '[Doctors List Page] Doctors Deleted',
  DoctorsPageRequested = '[Doctors List Page] Doctors Page Requested',
  DoctorsPageLoaded = '[Doctors API] Doctors Page Loaded',
  DoctorsPageCancelled = '[Doctors API] Doctors Page Cancelled',
  DoctorsPageToggleLoading = '[Doctors] Doctors Page Toggle Loading',
  DoctorsActionToggleLoading = '[Doctors] Doctors Action Toggle Loading',
  ChangePassword = '[Doctors] Password changed',
  ThrowError = '[Doctors] ThrowError',
  ClearErrors = '[Doctors] ClearErrors',
  FireDoctorSuccess = '[Doctors] Fire Success',
}

export class DoctorOnServerCreated implements Action {
  readonly type = DoctorActionTypes.DoctorOnServerCreated;
  constructor(public payload: { doctor: Doctor }) {}
}

export class DoctorCreated implements Action {
  readonly type = DoctorActionTypes.DoctorCreated;
  constructor(public payload: { doctor: Doctor }) {}
}

export class ThrowError implements Action {
  readonly type = DoctorActionTypes.ThrowError;

  constructor(public payload: { error: any }) {}
}

export class ClearErrors implements Action {
  readonly type = DoctorActionTypes.ClearErrors;
}
export class DoctorOnServerUpdated implements Action {
  readonly type = DoctorActionTypes.DoctorOnServerUpdated;
  constructor(
    public payload: {
      partialDoctor: Update<Doctor>;
      doctor: Doctor;
    },
  ) {}
}
export class DoctorUpdated implements Action {
  readonly type = DoctorActionTypes.DoctorUpdated;
  constructor(
    public payload: {
      partialDoctor: Update<Doctor>;
      doctor: Doctor;
    },
  ) {}
}

export class DoctorStatusOnServerUpdated implements Action {
  readonly type = DoctorActionTypes.DoctorStatusOnServerUpdated;
  constructor(public payload: { id: number; is_active: boolean }) {}
}

export class DoctorStatusUpdated implements Action {
  readonly type = DoctorActionTypes.DoctorStatusUpdated;
  constructor(public payload: { id: number; is_active: boolean }) {}
}

export class DoctorOnServerDeleted implements Action {
  readonly type = DoctorActionTypes.DoctorOnServerDeleted;
  constructor(public payload: { id: number }) {}
}

export class DoctorDeleted implements Action {
  readonly type = DoctorActionTypes.DoctorDeleted;
  constructor(public payload: { id: number }) {}
}

export class DoctorsPageRequested implements Action {
  readonly type = DoctorActionTypes.DoctorsPageRequested;
  constructor(public payload: { page: QueryParamsModel }) {}
}

export class DoctorsPageLoaded implements Action {
  readonly type = DoctorActionTypes.DoctorsPageLoaded;
  constructor(public payload: { doctors: Doctor[]; totalCount: number; page: QueryParamsModel }) {}
}

export class DoctorsPageCancelled implements Action {
  readonly type = DoctorActionTypes.DoctorsPageCancelled;
}

export class DoctorsPageToggleLoading implements Action {
  readonly type = DoctorActionTypes.DoctorsPageToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export class DoctorsActionToggleLoading implements Action {
  readonly type = DoctorActionTypes.DoctorsActionToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export class ChangePassword implements Action {
  readonly type = DoctorActionTypes.ChangePassword;
  constructor(public payload: { doctorName: string; oldPassword: string; newPassword: string }) {}
}

export class FireDoctorSuccess implements Action {
  readonly type = DoctorActionTypes.FireDoctorSuccess;
  constructor(public payload: { action_type: string }) {}
}

export type DoctorActions =
  | DoctorCreated
  | DoctorUpdated
  | DoctorDeleted
  | DoctorOnServerCreated
  | DoctorOnServerUpdated
  | DoctorOnServerDeleted
  | DoctorStatusOnServerUpdated
  | DoctorsPageLoaded
  | DoctorsPageCancelled
  | DoctorsPageToggleLoading
  | DoctorsPageRequested
  | ChangePassword
  | DoctorStatusUpdated
  | ThrowError
  | ClearErrors
  | DoctorsActionToggleLoading
  | FireDoctorSuccess;
